import RemoveIcon from '@mui/icons-material/Remove';
import { Box, CardContent, Grid, Tooltip, Stack, Typography, Button } from '@mui/material';
import './OrderCard.scss';
import { trim } from 'lodash';
import React from 'react';
import { useTranslation } from 'react-i18next';
import OrderMenu from '../OrderMenu/OrderMenu';
import { OrderCardProps } from './OrderCard';
import useOrderCardService from './useOrderCardService';

const OrderDraftedCardContent: React.FC<OrderCardProps> = ({ order, menu = true }) => {
  const [t] = useTranslation();
  const { orderClient, engagementDate, finalAmountPrice } = useOrderCardService(order);

  return (
    <CardContent>
      <Grid container spacing={4} justifyContent="space-between">
        <Grid item xs={12} md>
          <Grid
            container
            spacing={4}
            sx={{ '& .MuiGrid-item': { width: 0 }, justifyContent: 'space-between', alignItems: 'center' }}
          >
            <Grid item xs={12} md={6} lg={2}>
              
                {order.affair ? (
                  <Tooltip title={trim([order.affair?.otp, order.affair?.name].join(' - '))}>
                    <div>
                      <Typography noWrap className="order-card-title">
                        {order.affair?.otp}
                      </Typography>
                      <Typography noWrap className="order-card-title">
                        {order.affair?.name}
                      </Typography>
                    </div>
                  </Tooltip>
                ) : (
                <Typography noWrap>{t('Affair_Not_Indicated')} </Typography>
                )}
           
            </Grid>
            <Grid item xs={12} md={6} lg={2}>
              <Typography noWrap className="order-card-label">
                {t('Client')}
              </Typography>
              <Tooltip title={orderClient()}>
                <Typography noWrap className="order-card-value">
                  {orderClient()}
                </Typography>
              </Tooltip>
            </Grid>
            <Grid item xs={12} md={6} lg={2}>
              <Typography className="order-card-label">{t('Project_Name')}</Typography>
              <Tooltip title={order?.name_spec}>
                <Typography noWrap className="order-card-value">
                  {order?.name_spec || 'Not defined'}
                </Typography>
              </Tooltip>
            </Grid>
            <Grid item xs={12} md={6} lg={2} sx={{ display: 'none' }}>
              <Typography className="order-card-label">{t('Chrono reference')}</Typography>
              <Tooltip title={order.draft_reference ?? t<string>('Not_Defined')}>
                {order.draft_reference ? (
                  <Typography noWrap className="order-card-value">
                    {order.draft_reference}
                  </Typography>
                ) : (
                  <RemoveIcon color="disabled" />
                )}
              </Tooltip>
            </Grid>
            <Grid item xs={12} md={6} lg={2}>
              <Typography className="order-card-label">{t('Engagement_Date')}</Typography>
              <Tooltip title={engagementDate()}>
                <Typography noWrap className="order-card-value">
                  {engagementDate()}
                </Typography>
              </Tooltip>
            </Grid>
            <Grid item xs={12} md={6} lg={2}>
              <Box>
                <Typography className="order-card-label">{t('Price')}</Typography>
                <Tooltip title={finalAmountPrice()}>
                  <Typography noWrap className="order-card-value">
                    {finalAmountPrice()}
                  </Typography>
                </Tooltip>
              </Box>
            </Grid>
          </Grid>
        </Grid>
        <Grid
          item
          xs={12}
          md="auto"
          sx={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center' }}
        >
          <Stack spacing={2} direction="row" sx={{ alignItems: 'center' }}>
            <Button variant="contained" sx={{ visibility: 'hidden' }}>
              {t('Go Ahead')}
            </Button>
          {menu && <OrderMenu order={order} />}
          </Stack>
        </Grid>
      </Grid>
    </CardContent>
  );
};

export default OrderDraftedCardContent;
